import { lazy } from "react";

const AuthCallback = lazy(() => import("."));

export const AuthCallbackUrls = [{ link: "/auth_callback", component: AuthCallback }];
